import { combineReducers } from 'redux'
import app from './app'
import params from './param'
import home from './home'
import login from './login'
import admin from './admin'
import sellerList from './sellerList'
import sellerPointList from './sellerPointList'
import sellerPointForm from './sellerPointForm'
import sellerForm from './sellerForm'
import sellerBalanceForm from './sellerBalanceForm'
import sellerButtonMenuForm from './sellerButtonMenuForm'
import actionList from './actionList'
import actionForm from './actionForm'
import goods from './goods'
import sellers from './sellers'
import userList from './userList'
import userForm from './userForm'
import userSellerMenuForm from './userSellerMenuForm'
import sellerChatList from './sellerChatList'
import sellerChatForm from './sellerChatForm'
import roleList from './roleList'
import roleForm from './roleForm'
import roleButtonMenuForm from './roleButtonMenuForm'
import chatbotsButtonsController from './chatbotsButtonsController'

export default combineReducers({
  app,
  params,
  home,
  login,
  admin,
  sellerList,
  sellerPointList,
  sellerPointForm,
  sellerForm,
  sellerBalanceForm,
  sellerButtonMenuForm,
  actionList,
  actionForm,
  goods,
  sellers,
  userList,
  userForm,
  userSellerMenuForm,
  sellerChatList,
  sellerChatForm,
  roleList,
  roleForm,
  roleButtonMenuForm,
  chatbotsButtonsController,
})



// WEBPACK FOOTER //
// src/reducers/index.js